/*** IMPORTS FROM imports-loader ***/
import "core-js/modules/es.promise";
import "core-js/modules/es.array.iterator";

import $ from 'jquery';

$(document).ready(async function () {

	// Responsive menu
	$('header').each(function () {
		var element = $(this),
			body = $(document.body),
			responsiveNav = $('.responsive-nav');

		var toggler = $('.toggler').click(function () {
			responsiveNav.toggleClass('-collapsed');
			toggler.toggleClass('-closed');
			toggler.find('.hamburger').toggleClass('is-active')
		});
	});

	// Close menu after scroll
	$('.nav-main a').each(function () {
		var link = $(this);

		if (this.href.includes('#')) {
			link.on('click', function () {
				var toggler = $('.toggler'),
					responsiveNav = $('.responsive-nav');

				responsiveNav.toggleClass('-collapsed');
				toggler.toggleClass('-closed');
				toggler.find('.hamburger').toggleClass('is-active')

				//var target = $(link.hash);

				//if (!target.length) {
				//	target = $('[name=' + this.hash.slice(1) + ']');
				//}

				//if (target.length) {
				//	$('html, body').animate({
				//		scrollTop: target.offset().top
				//	}, 500);

				//	return false;
				//}
			});
		}
	});

	// Parralax background
	var el = $('#container');
	$(window).on('scroll', function () {
		var scroll = $(document).scrollTop();
		el.css({
			'background-position': '50% ' + (-.2 * scroll) + 'px'
		});
	});

	// Equellize height
	//if (document.querySelectorAll('.match-min-height').length) {
	//	new ResponsiveAutoHeight('.match-min-height');
	//}

	// Lightbox
	$('body:has([rel=lightbox])').each(async function () {
		await import('lightgallery');

		$(this).lightGallery({
			selector: '[rel=lightbox]',
			download: false,
			thumbnail: false,
			fullScreen: false,
			actualSize: false,
			hash: false
		});
	});

	// Lightbox
	$('.image-gallery:has([rel=image-gallery])').each(async function () {
		await import('lightgallery');

		$(this).lightGallery({
			selector: '[rel=image-gallery]',
			download: false,
			thumbnail: false,
			fullScreen: false,
			actualSize: false,
			hash: false
		});
	});

	// Slideshow
	$('.slideshow').each(async function () {
		const Swiper = (await import('swiper/dist/js/swiper.js')).default;

		var mySwiper = new Swiper('.slideshow.swiper-container', {
			loop: true,
			grabCursor: true,
			autoplay: {
				delay: 3000
			},
			speed: 1500,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			}
		})
	});

	// slider
	$('.employee__slider').each(async function () {
		const Swiper = (await import('swiper/dist/js/swiper.js')).default;

		var mySwiper = new Swiper('.employee__slider.swiper-container', {
			slidesPerView: 3,
			loop: true,
			grabCursor: true,
			autoplay: {
				delay: 3500
			},
			speed: 1000,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				425: {
					slidesPerView: 1
				}
			}
		})
	});

	$('.google-maps').each(async function () {
		var maps = $(this);
		var apiKey = maps.data('key');
		var dataGeolocation = maps.data('center').split(',');

		const loadGoogleMapsApi = (await import('load-google-maps-api')).default;
		const googleMaps = await loadGoogleMapsApi({
			key: apiKey
		});

		var myLatLng = {
			lat: parseFloat(dataGeolocation[0]),
			lng: parseFloat(dataGeolocation[1])
		};

		var map = new googleMaps.Map(maps[0], {
			center: myLatLng,
			zoom: 13,
			zoomControl: true,
			mapTypeControl: true,
			scaleControl: true,
			streetViewControl: true,
			rotateControl: false,
			fullscreenControl: true,
			backgroundColor: 'none',
			styles: [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#000000" }, { "lightness": 40 }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "administrative", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.country", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "administrative.country", "elementType": "geometry", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "administrative.country", "elementType": "labels.text", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "administrative.province", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.locality", "elementType": "all", "stylers": [{ "visibility": "simplified" }, { "saturation": "-100" }, { "lightness": "30" }] }, { "featureType": "administrative.neighborhood", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.land_parcel", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "visibility": "simplified" }, { "gamma": "0.00" }, { "lightness": "74" }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "landscape.man_made", "elementType": "all", "stylers": [{ "lightness": "3" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 21 }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 17 }] }]
		});

		var image = {
			url: (window.baseUrl || '/') + "umbraco/surface/webpack/images?name=marker-icon.png",
			scaledSize: new google.maps.Size(90, 105),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(45, 105)
		};

		var marker = new google.maps.Marker({
			position: myLatLng,
			map: map,
			icon: image
		});

	});

	// Route form
	$('.route-form').each(function () {
		var element = $(this);
		var button = element.find('button');
		var destinationAddress = element.find('input[type=text]');
		var destination = element.find('#To');

		// Route on button click
		button.click(function (e) {
			var route = {
				saddr: destinationAddress.val(),
				daddr: destination.val()
			};

			window.open('https://maps.google.com/?' + $.param(route), '_blank');

			e.preventDefault();
		});
	});

	// Smooth scroll
	$('a[href*=\\#]').click(function () {
		var target = $(this.hash);

		if (!target.length) {
			target = $('[name=' + this.hash.slice(1) + ']');
		}

		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top
			}, 500);

			return false;
		}
	});

	$('.modal').each(async function () {
		var Cookies = (await import('js-cookie')).default;

		var modalId = 'modal';
		var cookieName = 'modal',
			ignoredIds = Cookies.get(cookieName),
			ignoreId = function (id) {
				if (ignoredIds) ignoredIds += ',' + id;
				else ignoredIds = id;

				Cookies.set(cookieName, ignoredIds, { expires: 1 });
			};

		if (!ignoredIds || !ignoredIds.includes(modalId)) {
			var modal = $(this);
			var close = modal.find('.modal-close');

			modal.addClass('is-visible');

			close.click(function () {
				modal.removeClass('is-visible');
				ignoreId(modalId);
			});

			modal.find('a.button').click(function () {
				modal.removeClass('is-visible');
				ignoreId(modalId);
			});

			modal.find('.modal-background').click(function () {
				modal.removeClass('is-visible');
				ignoreId(modalId);
			});
		}
	});
});